import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

// https://uxwing.com/google-round-icon/
export function Google(props: SvgIconProps){
  return <SvgIcon width="64" height="64" viewBox="0 0 640 640"
    shapeRendering="geometricPrecision" textRendering="geometricPrecision"
    imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd"
    {...props}
  >
    <path d="M320 0C143.234 0 0 143.234 0 320s143.234 320 320 320 320-143.234
      320-320S496.766 0 320 0zm4.76 560.003C192.12 560.003 84.757 452.651 84.757
      320c0-132.651 107.364-240.003 240.003-240.003 64.772 0 118.998 23.646
      160.774 62.753l-65.115 62.764c-17.894-17.114-49.005-36.992-95.647-36.992C242.78
      168.522 176.01 236.4 176.01 320c0 83.6 66.887 151.478 148.762 151.478
      95.01 0 130.643-68.233 136.124-103.513l-136.136-.012v-82.241l226.633.012c1.996
      12.012 3.768 24.012 3.768 39.768.118 137.116-91.761 234.523-230.353
      234.523l-.047-.012z"/>
  </SvgIcon>
}

export function Cabbage(props: SvgIconProps){
  return <SvgIcon x="0px" y="0px" viewBox="0 0 54.849 54.849"
    enableBackground="new 0 0 54.849 54.849"
    {...props}
  >
    <g>
      <path style={{fill: "#659C35"}} d="M47,46.111c7.91-7.673,10.228-19.813,5.172-29.557c-0.449-0.865-0.631-1.862-0.358-2.797
		    c0.192-0.657,0.543-1.325,1.186-1.646c0,0-1.917-3.5-6,1c0,0-7.583,5.917,0,16c0,0,3.812,3.531,1,13L47,46.111L47,46.111z"/>
      <path style={{fill: "#A4E869"}} d="M47,46.111l1-4c2.812-9.469-1-13-1-13c-7.583-10.083,0-16,0-16c0.633-0.698,1.208-1.185,1.738-1.541
        C44.157,6.385,37.463,3.111,30,3.111c-1.488,0-2.944,0.138-4.36,0.387C24.339,0.603,22,1.111,22,1.111
        c-2.008,0-2.37,3.071-2.436,4.283c-2.75,1.265-5.232,3.011-7.334,5.135c-1.115,1.018-2.148,2.128-3.068,3.33
        c0.092,0.013,0.185,0.026,0.275,0.037c-8.041-1.188-9.242,2.102-9.416,3.027c-0.026,0.136-0.028,0.275-0.011,0.413
        c0.267,2.222,1.796,3.418,2.789,3.969c0.506,0.281,0.743,0.866,0.625,1.434C-1.392,45.891,26.656,62.99,44.866,48.321
        c0.116-0.094,0.204-0.205,0.279-0.323C45.74,47.544,47.091,46.023,47,46.111z"/>
      <path style={{fill: "#88C057"}} d="M9.874,13.957c0.037,0.006,0.069,0.012,0.105,0.021c0.685,0.16,7.555,1.999,9.884,11.69
        c0,0,0.482,4.223,5.055,5.174c0.198,0.041,0.4-0.008,0.602-0.02c2.94-0.181,9.419-2.029,9.358,5.46c0,0-2.245,10.104,9.111,9.686
        c0.251-0.009,0.507,0.05,0.723,0.179c0.017,0.01,0.028,0.024,0.044,0.034C50.372,30.766,38,29.111,38,29.111s-14.25-0.625-12-15
        s-4-13-4-13c-2.5,0-2.45,4.769-2.45,4.769c-4.11,1.669-7.697,4.465-10.387,7.979C9.4,13.893,9.624,13.916,9.874,13.957z"/>
      <path style={{fill: "#659C35"}} d="M44.866,48.321C26.656,62.99-1.392,45.891,3.425,22.74c0.118-0.568-0.118-1.153-0.625-1.434
        c-0.993-0.551-2.522-1.747-2.789-3.969c-0.017-0.138-0.014-0.276,0.011-0.413c0.177-0.942,1.403-4.349,9.852-2.968
        c0.037,0.006,0.069,0.012,0.105,0.02c0.685,0.16,7.555,1.999,9.884,11.69c0,0,0.482,4.223,5.055,5.174
        c0.198,0.041,0.4-0.008,0.602-0.02c2.94-0.181,9.419-2.029,9.358,5.46c0,0-2.245,10.104,9.111,9.686
        c0.251-0.009,0.507,0.05,0.723,0.179l0,0C45.505,46.617,45.584,47.742,44.866,48.321z"/>
    </g>
  </SvgIcon>
}